import { useEffect } from 'react';
import { httpClient } from '../utils/apiCall';
import { useLoading } from '../contexts/LoadingContext';

/**
 * HttpClient'ı loading context ile bağlayan hook
 * Bu hook App.tsx'de kullanılmalı
 */
export const useHttpClient = () => {
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    // HttpClient'a loading callback'lerini bağla
    httpClient.setLoadingCallbacks({
      showLoading,
      hideLoading,
    });

    // Cleanup function
    return () => {
      httpClient.setLoadingCallbacks({});
    };
  }, [showLoading, hideLoading]);
};
